<template>
  <div class="loginpage">
    <section class="hero">
      <div class="login-container">
        <img alt="KK logo" src="../assets/kk-logo-red.svg">

        <form class="form" @submit.prevent="handleSubmit">
           <input type="text" name="username" v-model="username" placeholder="Kundennummer" :class="{ 'is-invalid': submitted && !username }">
           <div v-show="submitted && !username" class="invalid-feedback">Username is required</div>
           <br>
           <input type="password" name="password" v-model="password" placeholder="Passwort" :class="{ 'is-invalid': submitted && !password }">
           <div v-show="submitted && !password" class="invalid-feedback">Password is required</div>
           <br><br>
           <button v-show="!loggingIn" type="submit" :disabled="loggingIn">Einloggen</button>
           <img v-show="loggingIn" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
        </form>
      </div>
      <div class="fixedonbottom pointer" v-on:click="scrtnxtsctn">
        <h3 >Das erwartet Sie hier</h3>
        <i class="icon icon-chevron-down"></i>
      </div>
    </section>
    <section class="section" id="home_content">
      <article>
        <div class="columns flex wrap valign-middle align-center">
          <div class="column">
            <h1>Marktfrisch und pünktlich zu Ihnen.</h1>
            <h2>Obst und Gemüse von Konrad Koester.</h2>
          </div>
        </div>
        <div class="columns flex wrap valign-middle max">
          <div class="column">
            <img src="/upload/content/Kraeuter_Hintergrund_1.jpg" alt="Fruchtgroßhandel Düsseldorf Konrad Köster">          
          </div>
        </div>
      </article>
      <article>
      <div class="columns flex wrap valign-middle half">
        <div class="column">
            <img src="/upload/content/KK_LIEFERGEBIET_2019-b.jpg" alt="Fruchtgroßhandel Düsseldorf Konrad Köster Liefergebiet">
        </div>
        <div class="column">
            <h1>Was? Wann? Wo?</h1>
            <h2>Ganz wie Sie möchten! 
              Ganz frisch!</h2>
              <p>Ganz gleich wie exotisch das Obst oder Gemüse, das Sie bei uns bestellen, auch ist: wir liefern! Wann Sie wollen und wohin sie wollen. Ganz nach Ihren Wünschen und Bedürfnissen, direkt vom Grossmarkt Düsseldorf bis zu Ihnen. Und damit alles perfekt läuft, werden Sie von einem Fahrer persönlich betreut.</p>
        </div>
      </div>
      </article>
      <article>
      <div class="columns flex wrap valign-middle half">
        <div class="column">
          <h1>Zuverlässig.</h1>
          <h2>Pünktlich. Frisch.</h2>
          <p>Seit fast 30 Jahren liefert das Konrad Koester Team erstklassigen Service, Qualität und Frische direkt vom Düsseldorfer Grossmarkt.<br>
          <br>
          Was 1988 mit einem gebrauchten Hanomag Lieferwagen begann, ist heute ein leistungsfähiges Serviceunter­nehmen mit 28 Mitarbeitern. Dazu gehört eine Flotte moderner Lieferfahrzeuge, die alle über Kühlung und spezielle Ausstattung nach haccp-Hygienestandards verfügen.<br>
          <br>
          Ohne jede Lagerzeit stellen wir die von Ihnen bestellte Ware zusammen und liefern sie täglich direkt vom Grossmarkt. <br>
          <br>
          Absolut pünktlich. Absolut zuverlässig. Absolut frisch.</p>
        </div>
        <div class="column">
          <img class="r" src="/upload/content/kk-team.jpg" alt="Fruchtgroßhandel Düsseldorf Konrad Köster">
        </div>
      </div>
      </article>
    </section>
  </div>
</template>
<script>
export default {
    data () {
        return {
            username: '',
            password: '',
            submitted: false
        }
    },
    computed: {
        loggingIn () {
            return this.$store.state.authentication.status.loggingIn;
        }
    },
    created () {
        // reset login status
        this.$store.dispatch('authentication/logout');
    },
    methods: {
        scrtnxtsctn() {
          $('html,body').animate({ scrollTop: $('#home_content').position().top },800);
        },

        handleSubmit (e) {
            this.submitted = true;
            const { username, password } = this;
            const { dispatch } = this.$store;
            if (username && password) {
                dispatch('authentication/login', { username, password });
            }
        }
    }
};
</script>
<style scoped>
  .loginpage {  }

  section.hero { display: flex; align-items: center; justify-content: center; min-height: 100vh; padding: 2.7999999em 0 4em; background: #fff url(/upload/content/kk-fruechte.jpg) center 10% no-repeat; background-size: 95%;  position: relative;
    border: 0px solid #e30613 }

  .login-container { max-width: 40em; padding-bottom: 3em; background: rgba(255,255,255,0.7); padding: 2.79999em; border-radius: 3px;  transform:translateY(0em);}
  @media screen and ( min-width: 768px) {
    .login-container { background: rgba(255,255,255,0.9);  }
    section.hero { background-size: 55%; }
  }

  .error { border: 1px solid #dc1200; padding: 0.6333333em; margin: 0 0 0.9333333em 0; background: rgba(245, 17, 17, 0.12) }
  .close { text-decoration: none; color: #dc1200; font-size: bold;}

  img { display: block; max-width: 100%; }
  .login-container img { max-width: 10em; margin: 0 auto 0.9333333em; }
  input { border: 1px solid #ddd; border-radius: 3px; padding: 0.4333333em 0.9333333em; margin-bottom: 0.33333em; outline: 0; transition: border-color 0.2s; font-size: 1.2rem; }
  input:focus { border-color: #00853e; }
  button { background: #00853e; border: 0; color: #fff; padding: 0.4333333em 0.9333333em; border-radius: 3px; transition: transform 0.5s; font-size: 1.2rem; }
  button:hover { transform: scale(1.00) }

  .fixedonbottom { position: absolute; bottom: 1em; left: 50%; transform:translateX(-50%); text-align: center;  }
  .fixedonbottom h3 { font-weight: 300; padding: 0; margin: 0; }
  .icon.icon-chevron-down { display: block; width: 3rem; height: 3rem; background: url(/img/icons-red/chevron-down.svg) center center no-repeat; background-size: contain; margin: 0 auto; }
  .pointer { cursor:pointer;}

  #home_content { min-height: 100vh; padding: 0 0 5em;  }
  #home_content article { padding: 2.733333em 0; }
  article h1 { color: #00853e; font-size: 2.83333rem; border: 0 solid red; margin: 0; }
  article h2 { color: #00853e; font-size: 2.8333333em; }
  article h1 + h2 { padding: 0; margin: 0; }



</style>
